import { registerSW } from 'virtual:pwa-register';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { toast } from 'sonner';
import { App } from './App';
import './index.css';

// Service worker (PWA offline-first). `registerType: 'prompt'` en vite.config:
// cuando hay versión nueva NO recargamos solos (eso borra lo que el usuario esté
// escribiendo, ej. el login) — mostramos un aviso con botón "Recargar".
const actualizarSW = registerSW({
  onNeedRefresh() {
    toast('Hay una versión nueva disponible', {
      duration: Number.POSITIVE_INFINITY,
      action: { label: 'Recargar', onClick: () => actualizarSW(true) },
    });
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = document.getElementById('root');
if (!root) {
  throw new Error('No se encontró #root en index.html');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
